import { AppState, TOGGLE_DARKMODE } from './types';
import { Action } from '../types';

const initialState: AppState = {
  ready: false,
  apiError: false,
  isDarkMode: false,
};

export const appReducer = (
  state: AppState = initialState,
  action: Action
): AppState => {
  switch (action.type) {
    case TOGGLE_DARKMODE: {
      const { isDarkMode } = action.payload || {};

      return {
        ...state,
        isDarkMode,
      };
    }

    default:
      return state;
  }
};

export default appReducer;

